import React, { Component } from "react";
import ReactDOM from "react-dom";
import WebRtcStreamer from "../../webrtc/webrtcstreamer.js";

// import "../../webrtc/request.min.js";
import IntercomPad from "./Intercom/IntercomPad.jsx";

const OPTIONS = "rtptransport=tcp&timeout=60";
const video_states = {
    OK: "OK",
    STALLED: "STALLED",
    ERROR: "ERROR",
    LOADING: "LOADING",
    LOADED: "LOADED",
};
const IMAGE_POLL_PERIOD_MS = 250 ;
const KEEP_ALIVE_PERIOD_MS = 15000 ;
const RECONNECT_WHEN_STALLED_FOR = 15000;
class Pane extends Component {
  constructor() {
    super();
    

    this.checkVideoIsStalled = this.checkVideoIsStalled.bind(this);
    this.connectStream = this.connectStream.bind(this);
    this.disconnectStream = this.disconnectStream.bind(this);
    this.reconnectButton = this.reconnectButton.bind(this);
    this.videoPoller = this.videoPoller.bind(this);
    this.setVideoStatus = this.setVideoStatus.bind(this);
    this.sendKeepAlive = this.sendKeepAlive.bind(this);
    this.onCanPlay = this.onCanPlay.bind(this);
    this.onError = this.onError.bind(this);
    this.onLoadedData = this.onLoadedData.bind(this);
    this.onLoadStart = this.onLoadStart.bind(this);
    this.videoEvent = this.videoEvent.bind(this);
    this.setLowResolution = this.setLowResolution.bind(this);
    this.setHighResolution = this.setHighResolution.bind(this);
    this.changeRes = this.changeRes.bind(this);
    this.webRtcServer = undefined;
    this.poll_timer = undefined;
    this.keep_alive_timer = undefined;
    this.uid = "video-" + Math.random() + "-";
    this.state = {
      video_event: undefined,
      prev_image_data: undefined,
      video_stalled: false,
      video_stall_started_at: null,
      quality_failed_count: 0,
      quality_calculation_at: null,
      quality_value: null,
      quality_average: null,
      quality_values: [],
      first_stale_detected_at: null,
      
    }
    this.high_res = false;

  }
  videoPoller(ms){
    
    clearTimeout(this.poll_timer);
    if (
        this.state.video_stall_started_at != null && 
        new Date().getTime() - this.state.video_stall_started_at > RECONNECT_WHEN_STALLED_FOR
      ){
        this.setState({video_stall_started_at: null})
        this.connectStream();
      }
    this.poll_timer = setTimeout(this.checkVideoIsStalled, ms);
  }

  componentDidMount() {
    this.webRtcServer = new WebRtcStreamer(this.uid + this.props.camId, "/streamer");
    this.connectStream();
    this.keep_alive_timer = setTimeout(this.sendKeepAlive, KEEP_ALIVE_PERIOD_MS);
  }
  componentWillUnmount() {
    this.disconnectStream();
    clearTimeout(this.keep_alive_timer)
    clearTimeout(this.poll_timer)
  }
  connectStream() {
    
    // this.webRtcServer.connect(this.props.camId + ".low", undefined, OPTIONS);
    let cam_stream_name = this.props.camId;
    if (this.high_res === true){
      cam_stream_name += ".high"

    }
    else{
      cam_stream_name += ".low"
    }
    console.log("cam_stream_name", cam_stream_name);
    this.webRtcServer.connect(cam_stream_name, undefined, OPTIONS);
    this.videoPoller(1000);
  }
  reconnectButton(event) {
    event.stopPropagation();
    this.connectStream()
  }
  disconnectStream(){
    this.webRtcServer.disconnect();
    if(this.poll_timer)
      clearTimeout(this.poll_timer);

  }
  setLowResolution(){
    if (this.high_res === false){
      return;
    }
    this.changeRes(false);
  }
  setHighResolution(){
    if (this.high_res === true){
      return;
    }
    this.changeRes(true);


  }

  changeRes(high_res){
    console.log("setting resolution ", high_res);
    this.high_res=high_res;
    this.disconnectStream();
    this.connectStream();


  }

  checkVideoIsStalled () {
    let video = document.getElementById(this.uid + this.props.camId);
    if (!video){
      this.videoPoller(1000);
      this.setVideoStalled(false);
      return;  
    }

    let width = video.videoWidth;
    let height = video.videoHeight;
    if (!width || !height){
      this.videoPoller(1000);
      this.setVideoStalled(false);
      return;  
    }
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    let image = context.getImageData(0 ,0, video.videoWidth, video.videoHeight);
    
    // console.log("got image", image.data.length);
    let images_stalled = false;
    if (this.state.prev_image_data){
      images_stalled = are_images_equal(this.state.prev_image_data, image.data);
    }
    this.setState({prev_image_data : image.data})
    
    let video_is_stalled = false;
    let now = new Date().getTime();
    if (images_stalled){
      if (this.state.first_stale_detected_at == null){
        this.setState({first_stale_detected_at: now})  
      }
      else if (now - this.state.first_stale_detected_at > 3000){
        video_is_stalled = true;
      }
      this.setState({
        quality_failed_count: this.state.quality_failed_count+1,
        // signal:Math.max(this.state.signal-1,0)
      });
    }
    else if (this.state.first_stale_detected_at != null){
        this.setState({first_stale_detected_at: null});
    }
    if(this.state.quality_calculation_at == null){
      this.setState({
        quality_calculation_at:now,
        quality_failed_count:0
      })
    }
    else if(now - this.state.quality_calculation_at> 5000){
      let delta = now - this.state.quality_calculation_at;
      let fails_per_sec = (IMAGE_POLL_PERIOD_MS*this.state.quality_failed_count)/delta;
      let bad = 100*(Math.exp(fails_per_sec*1.6)%1);
      bad = Math.min(bad, 100);

      let quality = 100 - bad;
      let quality_value = Math.round(quality);
      let quality_values = [...this.state.quality_values ];
      quality_values.push(quality_value);
      if (quality_values.length > 3) {
        quality_values.shift();
      }
      let quality_average = quality_values.reduce((acum, current) =>acum+current );
      quality_average/= quality_values.length;
      quality_average = Math.round(quality_average);
      // console.log("quALITY calculated fails, fails_per_sec", this.state.quality_failed_count, fails_per_sec);
      this.setState({
        quality_calculation_at:now,
        quality_failed_count:0,
        quality_value,
        quality_values,
        quality_average,
      })

    }



    if (this.state.video_stalled != video_is_stalled){
      this.setVideoStalled(video_is_stalled);
    }
    this.videoPoller(IMAGE_POLL_PERIOD_MS);

  }
  onCanPlay() {
    this.videoEvent("onCanPlay") //ready (playing)
  }
  onError() {
    this.videoEvent("onError")
  }
  onLoadedData() {
    this.videoEvent("onLoadedData") //loaded
  }
  onLoadStart() {
    this.videoEvent("onLoadStart") //loading
  }

  onSome(ev) {
    this.videoEvent("onSome")
  }
  setVideoStatus(video_is_ok){
    this.props.setVideoStatus(this.props.camId, video_is_ok)
  }
  sendKeepAlive() {
    let status = getVideoStatus(this.state.video_event, this.state.video_stalled);
    if (status == video_states.OK){
      // console.log("sending keep alive")
      this.webRtcServer.keep_alive();
    }
    this.keep_alive_timer = setTimeout(this.sendKeepAlive, KEEP_ALIVE_PERIOD_MS);
  }

  videoEvent(event_str){
    console.log("video event " + event_str);
    this.setState({video_event: event_str})
    let status = getVideoStatus(event_str, this.state.video_stalled);
    if(status == video_states.OK){
      this.setVideoStatus(true);
    }
    else{
      this.setVideoStatus(false)
    }
  }
  setVideoStalled(video_stalled){
    let video_stall_started_at = null;
    if (video_stalled){
      if (this.state.video_stall_started_at == null){
        video_stall_started_at = new Date().getTime();
      }
    }
    this.setState({video_stalled, video_stall_started_at})
    let status = getVideoStatus(this.state.video_event, video_stalled);
    if(status == video_states.OK){
      this.setVideoStatus(true)
    }
    else{
      this.setVideoStatus(false)
    }

  }

  render() {
    let video_state = getVideoStatus(this.state.video_event, this.state.video_stalled);

    // let class_name = "video-status-content";
    // display-none
    // return <div>"video_event" + {this.state.video_event}</div>;
    // return <div className={class_name}>{ this.state.video_event}</div>
    
    let video_status = <div></div>;
    if (video_state != video_states.OK ){
      let messages = {}
      messages[video_states.STALLED] = `${this.props.camId} video is stalled`;
      messages[video_states.ERROR] = `There has been en error playing ${this.props.camId}`;
      messages[video_states.LOADING] = `Connecting to ${this.props.camId}`;
      messages[video_states.LOADED] = `Loaded ${this.props.camId}`;
      messages[video_states.OK] = `Video is ok ${this.props.camId}`;
      video_status = (
        <div className="video-status-content">
          <div className="flex flex-column justify-content-space-evenly">{ messages[video_state]}</div> 
          <button className="button-container button-reload" onClick={this.reconnectButton}>
            &#10227;
          </button>
        </div>
        );

    }
    let video_class_name = "";
    // let video_class_name = "video-not-ok";
    if (video_state != video_states.OK){
      video_class_name = " video-not-ok"
    }
    else if (this.props.hightlight === true){
      video_class_name += "video-highlight";

    }
    let quality_bar = undefined
    if (this.state.quality_average != null){
      let bar_style = {
        // 25 : .quality_bar_container width - quality_bar margin
        width: Math.round((this.state.quality_average*40)/100,0) +"px",
        backgroundColor: "hsl("+this.state.quality_average+",60%,40%)"
      }
      quality_bar =(
        <div className="quality_bar_container">
            <div className="quality_bar" style={bar_style}> 
              <div className="quality_value" > {this.state.quality_average}%</div>
            </div>
        </div>
      );

    }
    let low_btn_class = "button-container btn-mini2 horizontal-margin opactity-80 ";
    let high_btn_class = "button-container btn-mini2 horizontal-margin opactity-80 ";
    if(this.high_res ===  true){
      high_btn_class += "btn-camswitch-select-pressed-red"
    }
    else{
      low_btn_class += "btn-camswitch-select-pressed-secondary"
    }
    let high_res_div = undefined;
    if (this.props.showhighDefVideoSwitch == true){
      high_res_div = (
        <div className="high-res-buttons">
          <button className={low_btn_class} onClick={this.setLowResolution} >low</button>
          <button className={high_btn_class} onClick={this.setHighResolution} >high</button>
        </div>
      )

    }

    // }
    let intercom = undefined;
    if (this.props.intercom){
      intercom = <IntercomPad
           intercom_id={this.props.intercom.id}
        />;

    }


    const pane = (
        <div className={"grid-" + this.props.panesCount + "-video-container video-container "  }>
          <div className="video-info "> {high_res_div} {quality_bar} </div>
          <div className="intercom-container">  {intercom}</div>
          <div className="video-status"> 
            <div className="flex-grow-1"/>
            { video_status }
            <div className="flex-grow-1"/>
          </div>
          <video
            className={video_class_name}
            id={this.uid + this.props.camId}
            muted
            playsInline
            onCanPlay={this.onCanPlay}
            onError={this.onError}
            onLoadedData={this.onLoadedData}
            onLoadStart={this.onLoadStart}
          />

        </div>
      );
    // video.muted = true;
    // video.playsinline = true;
    return (pane);
  }
}

function are_images_equal(image1, image2){
  if (image1.length != image2.length){
    return false;
  }

  for (let i=0; i<image1.length; i++) {
    if (image1[i] != image2[i]){
      return false;
    }
    if(i > image1.length*0.4){
      // at 40% of lenght, most likely is the same video image
      return true;
    }


  }
  return true
};

function getVideoStatus(last_video_event, is_video_stalled){
  let status = undefined;
  if(last_video_event == "onCanPlay" && !is_video_stalled){
    return video_states.OK;
  }
  
  if(is_video_stalled){
    return video_states.STALLED;
  }
  
  let status_map = {
    "onError" : video_states.ERROR,
    "onLoadStart" : video_states.LOADING,
    "onLoadedData" : video_states.LOADED,
  }
  return status_map[last_video_event];
};


export default Pane;
